import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getMetaDataAsync } from 'store/settingAccount';
import { getSelectedCentre } from 'store/master';

// ** Logo

const SpinnerComponent = ({ isLogo }) => {
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const selectedCentre = useSelector(getSelectedCentre);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getMetaDataAsync());
  }, []);
  return (
    <div className="fallback-spinner vh-100 flexRow justify-content-center align-items-center">
      {isLogo &&
        ((metaData?.logo && metaData?.logo[320]) ||
          metaData?.logo?.root ||
          selectedCentre?.thumbnail) && (
          <img
            src={
              selectedCentre?.thumbnail
                ? process.env.NEXT_PUBLIC_DOMAIN_IMG_HOST +
                  selectedCentre?.thumbnail
                : (metaData?.logo && metaData?.logo[320]) ||
                  metaData?.logo?.root
            }
            className="image-logo-loading"
            alt="logo"
          />
        )}
      <div className="loading">
        <div className="effect-1 effects" />
        <div className="effect-2 effects" />
        <div className="effect-3 effects" />
      </div>
    </div>
  );
};

SpinnerComponent.defaultProps = {
  isLogo: true,
};

SpinnerComponent.propTypes = {
  isLogo: PropTypes.bool,
};

export default SpinnerComponent;
